import OverbookedPassenger from '@/views/OverbookedPassenger/index.vue'

const OverbookedPassengerRouter = {
  path: '/overbooked-passenger',
  name: 'OverbookedPassenger',
  component: OverbookedPassenger,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default OverbookedPassengerRouter
